// In development with HTTPS, use proxy path to avoid mixed content issues (HTTPS frontend -> HTTP backend)
// The proxy (setupProxy.js) will forward /api/* requests to the HTTP backend
// Set REACT_APP_USE_PROXY=true in .env to enable proxy mode
const isDevelopment = process.env.NODE_ENV === 'development';
const useProxy = isDevelopment && (process.env.REACT_APP_USE_PROXY === 'true');

module.exports = {
    target_env: process.env.REACT_APP_NODE_ENV,
    // Use /api proxy in development when REACT_APP_USE_PROXY=true, otherwise use the full backend URL
    backEndBaseURL: useProxy ? '/api' : (process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:8080'),
    blockScreenSizeModal: process.env.REACT_APP_BLOCK_SCREEN_SIZE_MODAL ? process.env.REACT_APP_BLOCK_SCREEN_SIZE_MODAL : 'false',
}

